import { cn } from '~/shadcn/lib/utils'
import { InfoIcon } from '~/@mid_ui/icons/InfoIcon'
import { OnboardingSteps } from './OnboardingSteps'
import { Button } from '~/shadcn/ui/button/button'
import type { Step } from './steps'

interface Props {
  title: string
  bodyText: string
  buttonText: string
  isDark: boolean
  handleUpdateRegistration: any
  steps: Step[]
  activeStep: any
  colorScheme: any
}

export const BodyContent = ({
  title,
  bodyText,
  buttonText,
  isDark,
  handleUpdateRegistration,
  steps,
  activeStep,
  colorScheme,
}: Props) => {
  return (
    <div
      className={cn(
        'w-fit xl:w-full mx-auto p-4 rounded-lg',
        isDark
          ? 'bg-black border border-gray-800'
          : 'bg-[#FFF8EB] border border-[#FFCA61]',
        'flex flex-col xl:flex-row justify-between items-center gap-8 xl:gap-0'
      )}>
      <div className="flex flex-row gap-2 max-w-[400px]">
        <InfoIcon
          width={24}
          height={24}
          className={cn('mt-1.5 min-w-6', isDark ? 'text-white' : '')}
        />
        <div className="flex flex-col">
          <h2
            className={cn(
              'font-bold text-base',
              isDark ? 'text-white' : 'text-black'
            )}>
            {title}
          </h2>
          <p
            className={cn(
              'font-medium text-sm',
              isDark ? 'text-gray-300' : 'text-black'
            )}>
            {bodyText}
          </p>
          <Button
            variant="outline"
            size="small"
            className={cn(
              'hidden xl:flex w-fit mt-3',
              isDark
                ? 'text-white border-white hover:border-white'
                : 'text-black border-black hover:border-black'
            )}
            onClick={handleUpdateRegistration}>
            {buttonText}
          </Button>
        </div>
      </div>

      {/* Integrovaný stepper */}
      <OnboardingSteps
        steps={steps}
        activeStep={activeStep}
        colorScheme={colorScheme}
      />

      <Button
        variant="outline"
        size="small"
        className={cn(
          'flex xl:hidden w-fit mt-3',
          isDark
            ? 'text-white border-white hover:border-white'
            : 'text-black border-black hover:border-black'
        )}
        onClick={handleUpdateRegistration}>
        {buttonText}
      </Button>
    </div>
  )
}
